import cn from 'classnames/bind';
import * as React from 'react';
import { NotificationBar } from '../NotificationBar/index.js';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
class Notification {
    #message;
    #type;
    #id;
    constructor(message, type, id) {
        this.#message = message;
        this.#type = type;
        this.#id = id;
    }
    get message() {
        return this.#message;
    }
    get type() {
        return this.#type;
    }
    get id() {
        return this.#id;
    }
}
/**
 * Component that allows you to show multiple notifications. The notifications
 * are automatically removed after a specified timeout and it is possible to
 * limit the number of visible notifications.
 */
class NotificationsContainer extends React.Component {
    state = {
        notifications: [],
        visible: false,
    };
    componentDidUpdate(_, prevState) {
        const { notifications } = this.state;
        if (prevState.notifications.length !== notifications.length) {
            this.setState({
                visible: notifications.length !== 0,
            });
        }
    }
    push(message, type) {
        const notification = new Notification(message, type, Math.random());
        const notificationQueue = this.state.notifications.slice(0, this.props.max);
        this.setState({
            ...this.state,
            notifications: [notification, ...notificationQueue],
        });
    }
    render() {
        const { removeAfter, max, fixed } = this.props;
        const { visible } = this.state;
        return (React.createElement("div", { className: cx('notificationContainer', { fixed, visible }) }, this.state.notifications.slice(0, max).map((notification) => {
            return (React.createElement("div", { key: notification.id, className: cx('notification') },
                React.createElement(NotificationBar, { variant: notification.type, size: this.props.size, removeAfter: removeAfter * 1000, onRemoved: () => {
                        this.#remove(notification.id);
                    } }, notification.message)));
        })));
    }
    #remove(notificationId) {
        this.setState({
            ...this.state,
            notifications: this.state.notifications.filter((notification) => notification.id !== notificationId),
        });
    }
}

export { NotificationsContainer };
//# sourceMappingURL=index.js.map
